export const SET_PROPS = 'SET_PROPS'

export interface PropsAction {
  [other: string]: any
}

export type PROPS = { type: typeof SET_PROPS; payload: PropsAction }
